import Header from './components/Header';
import TickerBar from './components/TickerBar';
import Hero from './components/Hero';
import HotRank from './components/HotRank';
import NewsFeed from './components/NewsFeed';
import Channels from './components/Channels';
import SearchPills from './components/SearchPills';
import Special from './components/Special';
import Faq from './components/Faq';
import Trust from './components/Trust';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <TickerBar />
      <Header />
      <main>
        <Hero />
        <HotRank />
        <NewsFeed />
        <Channels />
        <SearchPills />
        <Special />
        <Faq />
        <Trust />
      </main>
      <Footer />
    </>
  );
}